export const env = {
    appVersion: import.meta.env.VITE_APP_VERSION ? import.meta.env.VITE_APP_VERSION : import.meta.env.DEV ? 'development' : 'unknown',
} as const;
